<template>
  <a-modal
    title="配置资源"
    :visible="visible"
    :mask-closable="false"
    :width="1500"
    :confirm-loading="loading"
    destroy-on-close
    @cancel="handleCancel"
  >
    <template slot="footer">
      <a-button
        @click="handleCancel"
      >
        取消
      </a-button>
      <a-popconfirm
        title="配比系数变动会影响确认数据，请确认是否保存"
        ok-text="确认"
        cancel-text="取消"
        :visible="popVisible"
        @confirm="confirmOk"
        @cancel="handleCancel"
      >
        <a-popconfirm
          :title="confirmReleaseTitle"
          cancel-text="取消"
          :visible="popReleaseVisible"
          @confirm="popReleaseCancel"
          @cancel="popReleaseCancel"
        >
          <a-button
            key="submit"
            type="primary"
            @click="handleOk"
          >
            确认
          </a-button>
        </a-popconfirm>
      </a-popconfirm>
    </template>
    <div>
      <a-button
        type="primary"
        @click="addResource"
      >
        添加资源
      </a-button>
    </div>

    <a-form-model
      ref="tableform"
      :model="form"
    >
      <a-table
        :columns="columns"
        :data-source="form.dataSource"
        :loading="loading"
        :pagination="false"
        :scroll="{ x: 1200 }"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => item.resourceId ? item.resourceId + index: index"
      >
        <template
          slot="productTypeIdList"
          slot-scope="text, record, index"
        >
          <a-form-model-item
            :key="index"
            :prop="'dataSource.'+index+'.productTypeIdList'"
            :rules="rules.productTypeIdListRule"
          >
            <a-select
              placeholder="请选择资源内容"
              :value="record.productTypeIdList"
              mode="multiple"
              :disabled="record.productSelect"
              style="width: 80%;"
              show-search
              :filter-option="filterOption"
              @change="handleChange($event, record, index)"
              @deselect="deselectChange($event)"
            >
              <!-- @deselect="deselectproductType($event, record, index)" -->
              <a-select-option
                v-for="item in productTypetions"
                :key="item.productTypeId"
              >
                {{ item.productTypeName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </template>

        <template
          slot="contractAmount"
          slot-scope="text, record, index"
        >
          <a-form-model-item
            :prop="'dataSource.'+index+'.contractAmount'"
            :rules="rules.contractAmountRule"
          >
            <a-input-number
              v-model="record.contractAmount"
              :parser="parser"
              style="width: 80%;"
              @change="contractAmountChange($event, record, index)"
            />
          </a-form-model-item>
        </template>

        <template
          slot="allocationAmount"
          slot-scope="text, record, index"
        >
          <a-form-model-item
            :prop="'dataSource.'+index+'.allocationAmount'"
            :rules="rules.allocationAmountRule"
          >
            <a-input-number
              v-model="record.allocationAmount"
              :parser="parser"
              style="width: 80%;"
              @change="allocationAmountChange($event, record, index)"
            />
          </a-form-model-item>
        </template>

        <template
          slot="quantity"
          slot-scope="text, record, index"
        >
          <a-form-model-item
            :prop="'dataSource.'+index+'.quantity'"
            :rules="rules.quantityRule"
          >
            <a-input-number
              v-model="record.quantity"
              :min="0"
            />
          </a-form-model-item>
        </template>

        <template
          slot="unit"
          slot-scope="text, record, index"
        >
          <a-form-model-item
            :prop="'dataSource.'+index+'.unit'"
            :rules="rules.unitRule"
          >
            <a-input
              v-model="record.unit"
            />
          </a-form-model-item>
        </template>

        <template
          slot="ratio"
          slot-scope="text, record, index"
        >
          <!-- <a-form-model-item
            :prop="'dataSource.'+index+'.ratio'"
            :rules="{
              required: true,
              validator: (rule, value, callback) => {
                checkRatioRule(rule, value, callback, record)
              },
              trigger: 'change'
            }"
          > -->
          <!-- <span class="ratioCenter">
              {{ `${record.ratio}%` }}
            </span> -->
          <a-form-model-item
            :prop="'dataSource.'+index+'.ratio'"
            :rules="rules.ratioRule"
          >
            <a-input-number
              v-model="record.ratio"
              :formatter="value => `${value}%`"
              :parser="value => value.replace('%', '')"
              style="width: 80%;"
              :min="0"
              @change="ratioChange($event, record, index)"
            />
          </a-form-model-item>
        </template>

        <!-- <template
          slot="availableAmount"
          slot-scope="text, record, index"
        >
          <a-form-model-item
            :key="index"
            :prop="'dataSource.'+index+'.availableAmount'"
          >
            <span class="ratioCenter">
              {{ `${record.availableAmount}` }}
            </span>
          </a-form-model-item>
        </template> -->

        <template
          slot="operatorAction"
          slot-scope="text, record, index"
        >
          <TableActions
            :actions="tableActions"
            :record="record"
            @delete="handleDelete(record, index)"
          />
        </template>
      </a-table>

      <AddResource
        :visible="typeVisible"
        @typeCancel="typeCancel"
        @typeOk="typeOk"
      />
      <div
        class="amountClass"
      >
        <a-row :gutter="24">
          <a-col :span="12">
            <div class="a-pad">
              <a-form-model-item
                label="回款总额:"
                prop="totalCollectionAmount"
                :rules="rules.totalCollectionAmountRule"
              >
                {{ form.totalCollectionAmount }}
              </a-form-model-item>
            </div>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12">
            <div class="a-pad">
              <a-form-model-item
                label="合计配置已回款额:"
                prop="totalConfigAmount"
                :rules="rules.totalConfigAmountRule"
              >
                {{ form.totalConfigAmount }}
              </a-form-model-item>
            </div>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12">
            <div class="a-pad">
              <a-form-model-item
                label="合计可发资源:"
                prop="totalDistribResources"
              >
                {{ form.totalDistribResources }}
              </a-form-model-item>
            </div>
          </a-col>
        </a-row>

        <a-row :gutter="24">
          <a-col :span="12">
            <div class="a-pad">
              <a-form-model-item
                label="合计应回款额:"
                prop="totalContractAmount"
              >
                {{ form.totalContractAmount }}
              </a-form-model-item>
            </div>
          </a-col>
        </a-row>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { configureResourcePack, checkProductTypeDelete, checkResourceDelete } from '@/api/resourceSetting.js'
import AddResource from './AddResourceType.vue'
import { deepClone, countSum, filterOption } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'

// import EdittableCell from './EdittableCell.vue'
const tableActions = [
  {
    title: '删除',
    type: 'link',
    action: 'delete'
  }
]
export default {
  components: {
    AddResource
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    resourceId: {
      type: String,
      default: null
    },
    initData: {
      type: Array,
      default: null
    },
    productTypetions: {
      type: Array,
      default: null
    },
    collectionAmount: {
      type: Number,
      default: null
    },
    contractId: {
      type: String,
      default: null
    }
  },

  data () {
    const checkTotalConfigAmount = (rule, value, callback) => {
      if (value !== Number(this.form.totalCollectionAmount)) {
        callback(new Error('回款总额应等于合计配置金额，请重新配置'))
      }
      callback()
    }

    const checkCollectionAmount = (rule, value, callback) => {
      if (value !== Number(this.form.totalConfigAmount)) {
        callback(new Error('回款总额应等于合计配置金额，请重新配置!'))
      }
      callback()
    }

    // const checkAvailableAmountRule = (rule, value, callback, record) => {
    //   if (record.availableAmount < record.distributionAmount) {
    //     callback(new Error('可发资源应大于已发资源!'))
    //   } else {
    //     callback()
    //   }
    //   // this.form.dataSource.forEach((item) => {
    //   //   if (item.availableAmount < item.distributionAmount) {
    //   //     console.log('callback')
    //   //     callback(new Error('可发资源应大于已发资源!'))
    //   //     return null
    //   //   }
    //   // })
    //   // callback()
    // }

    const checkAllocationAmount = (rule, value, callback) => {
      if (Number(value) < 0) {
        callback(new Error('配置金额应大于0!'))
      } else if (isNaN(value) || value === '' || value === null) {
        callback(new Error('配置金额不能为空!'))
      } else {
        callback()
      }
    }
    return {
      tableActions,
      form: {
        dataSource: [
        ],
        totalConfigAmount: 0.0,
        totalCollectionAmount: 0.0,
        totalDistribResources: 0.0,
        totalContractAmount: 0.0
      },
      popVisible: false,
      popReleaseVisible: false,
      rules: {
        productTypeIdListRule: { required: true, message: '资源内容不能为空', trigger: 'change' },
        allocationAmountRule: { required: true, validator: checkAllocationAmount, trigger: 'change' },
        contractAmountRule: { required: true, message: '应回款额不能为空', trigger: 'change' },
        // availableAmountRule: { required: true, validator: checkAvailableAmountRule, trigger: 'change' },
        totalCollectionAmountRule: {
          validator: checkCollectionAmount, trigger: 'change'
        },
        totalConfigAmountRule: {
          validator: checkTotalConfigAmount, trigger: 'change'
        },
        unitRule: { required: true, message: '单位不能为空', trigger: 'change' },
        ratioRule: { required: true, message: '资源包配比不能为空', trigger: 'change' },
        quantityRule: { required: true, message: '数量不能为空', trigger: 'change' }
      },
      loading: false,
      columns: [
        {
          title: '产品类型',
          dataIndex: 'resourceTypeName',
          key: 'resourceTypeName',
          align: 'center',
          width: '150px'
        },
        {
          title: '资源内容',
          dataIndex: 'productTypeIdList',
          key: 'productTypeIdList',
          width: '200px',
          scopedSlots: { customRender: 'productTypeIdList' },
          align: 'center'
        },
        {
          title: '资源包配比',
          dataIndex: 'ratio',
          key: 'ratio',
          width: '110px',
          scopedSlots: { customRender: 'ratio' },
          align: 'center'
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          key: 'quantity',
          scopedSlots: { customRender: 'quantity' },
          align: 'center',
          width: '100px'
        },
        {
          title: '单位',
          dataIndex: 'unit',
          key: 'unit',
          scopedSlots: { customRender: 'unit' },
          align: 'center',
          width: '100px'
        },
        {
          title: '应回款额',
          dataIndex: 'contractAmount',
          key: 'contractAmount',
          width: '150px',
          align: 'center',
          scopedSlots: { customRender: 'contractAmount' }
        },
        {
          title: '销售额',
          dataIndex: 'saleAmount',
          key: 'saleAmount',
          width: '150px',
          align: 'center'
        },
        {
          title: '已回款额',
          dataIndex: 'allocationAmount',
          key: 'allocationAmount',
          width: '150px',
          scopedSlots: { customRender: 'allocationAmount' },
          align: 'center'
        },
        {
          title: '可发资源',
          dataIndex: 'availableAmount',
          key: 'availableAmount',
          width: '160px',
          align: 'center'
        },
        {
          title: '已发资源',
          dataIndex: 'distributionAmount',
          key: 'distributionAmount',
          align: 'center',
          width: '160px'
        },
        {
          title: '剩余额度',
          dataIndex: 'remainAmount',
          key: 'remainAmount',
          width: '120px'
        },
        {
          title: '操作',
          dataIndex: 'operatorAction',
          key: 'operatorAction',
          width: '160px',
          scopedSlots: { customRender: 'operatorAction' },
          align: 'center'
        }
      ],
      pagination,
      typeVisible: false,
      count: 2,
      resourceIdCount: 1,
      availableAmount: 0,
      allocationAmount: 0,
      totalPayment: 0,
      isDelete: null,
      totalConfigAmount: 0,
      isDeleteShow: false,
      distributionAmount: 0,
      productTypeId: undefined,
      indexCount: 0,
      ratioState: 0,
      dataTempt: [],
      confirmReleaseTitle: ''
    }
  },
  watch: {
    visible: {
      deep: true,
      handler: function (data) {
        if (data) {
          this.form.totalCollectionAmount = Number(this.collectionAmount)
          if (this.initData.length > 0) {
          // Object.assign(this.dataSource, data)
            this.form.dataSource = this.deepClone(this.initData)
            this.dataTempt = this.deepClone(this.initData)
          } else {
            this.form.dataSource = [{
              key: 0,
              resourceTypeName: '资源包1',
              productTypeIdList: [],
              allocationAmount: '',
              ratio: '',
              availableAmount: '',
              distributionAmount: 0,
              resourceType: 1,
              contractAmount: 0,
              saleAmount: 0,
              unit: '个',
              quantity: 0
            }]
          }
          this.getNum()
          this.getTotal()
        }
      }
    }
  },
  methods: {
    countSum,
    filterOption,
    checkRatioRule (rule, value, callback, record) {
      if (Number(record.availableAmount) < Number(record.distributionAmount)) {
        callback(new Error('可发资源应大于已发资源，请重新配置配比!'))
      } else {
        callback()
      }
    },
    // 用逗号分隔数字
    formatter (value) {
      return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    // 把格式化后的字符串转换为数字
    parser (value) {
      return value.replace(/\$\s?|(,*)/g, '')
    },
    getTotal () {
      let totalConfigAmount = 0
      const totalConfigAmountArr = []
      let totalDistribResources = 0
      let totalContractAmount = 0
      for (var i = 0; i < this.form.dataSource.length; i++) {
        totalConfigAmountArr.push(this.form.dataSource[i].allocationAmount)
        totalDistribResources += Number(this.form.dataSource[i].availableAmount)
        totalContractAmount += Number(this.form.dataSource[i].contractAmount)
      }
      totalConfigAmount = this.countSum(totalConfigAmountArr)
      this.form.totalConfigAmount = totalConfigAmount
      this.form.totalDistribResources = totalDistribResources.toFixed(3)
      this.form.totalContractAmount = totalContractAmount.toFixed(3)
    },

    deepClone,
    getRatio (num1, num2) {
      let num = ''
      var baseNum1 = 0; var baseNum2 = 0
      var baseNum3, baseNum4
      try {
        baseNum1 = num1.toString().split('.')[1].length
      } catch (e) {
        baseNum1 = 0
      }
      try {
        baseNum2 = num2.toString().split('.')[1].length
      } catch (e) {
        baseNum2 = 0
      }

      baseNum3 = Number(num1.toString().replace('.', ''))
      baseNum4 = Number(num2.toString().replace('.', ''))
      if (baseNum3 === 0) {
        num = 0
        return num
      }
      this.ratioState = 1
      num = Number((baseNum4 * baseNum3) * 100 * Math.pow(10, baseNum1 + baseNum2)).toFixed(2)
      return num
    },

    numMulti (arg1, arg2) {
      if (arg1 == null || arg2 == null || isNaN(arg1) || isNaN(arg2)) {
        return 0
      }
      var n1, n2
      var r1, r2 // 小数位数
      try {
        r1 = arg1.toString().split('.')[1].length
      } catch (e) {
        r1 = 0
      }
      try {
        r2 = arg2.toString().split('.')[1].length
      } catch (e) {
        r2 = 0
      }
      n1 = Number(arg1.toString().replace('.', ''))
      n2 = Number(arg2.toString().replace('.', ''))
      return (n1 * n2 / Math.pow(10, r1 + r2)).toFixed(3)
    },

    addResource () {
      this.typeVisible = true
    },
    handleCancel () {
      this.popVisible = false
      this.$emit('cancel')
    },
    popReleaseCancel () {
      this.popReleaseVisible = false
    },
    async handleOk () {
      this.$refs.tableform.validate(async valid => {
        if (valid) {
          if (this.ratioState === 1) {
            // this.dataTempt.forEach((item, index) => {
            //   if (Number(this.dataTempt[index].distributionAmount) > 0) {
            //     if (Number(this.dataTempt[index].ratio) !== Number(this.form.dataSource[index].ratio)) {
            //       this.confirmReleaseTitle = `${item.resourceTypeName}存在发放数据，配比不可修改`
            //       this.popReleaseVisible = true
            //     }
            //   }
            // })
            if (!this.popReleaseVisible) {
              this.popVisible = true
            }
          } else {
            configureResourcePack({
              contractId: this.contractId,
              resourceList: this.form.dataSource
            }).then((data) => {
              this.$emit('ok')
              this.$message.success('配置资源成功!')
            })
          }
        }
      })
    },
    async confirmOk () {
      await configureResourcePack({
        contractId: this.contractId,
        resourceList: this.form.dataSource
      }).then((data) => {
        this.popVisible = false
        this.$emit('ok')
        this.$message.success('配置资源成功!')
      })
    },
    handleChange (e, record, index) {
      if (this.form.dataSource[index].productTypeIdList.length > e.length) {
        this.$confirm({
          title: '确定删除该条记录吗？',
          okText: '确认删除',
          cancelText: '取消',
          onOk: async () => {
            await checkProductTypeDelete(
              {
                resourceId: record.resourceId,
                productTypeId: this.productTypeId
              }
            ).then((data) => {
              if (data) {
                this.form.dataSource[index].productTypeIdList = e
                this.$message.success('该产品删除成功!')
              } else {
                this.$message.error('该产品不可删除!')
              }
            })
          },
          onCancel: () => {
            // this.form.dataSource[index].productTypeIdList.push(e)
          }
        })
      } else {
        this.form.dataSource[index].productTypeIdList = e
      }
    },
    deselectChange (e) {
      this.productTypeId = e
    },
    deselectproductType (e, record, index) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          await checkProductTypeDelete(
            {
              resourceId: record.resourceId,
              productTypeId: record.productTypeId
            }
          ).then((data) => {
            if (data) {

            } else {
              this.form.dataSource[index].productTypeIdList.push(e)
              this.$message.error('该产品不可删除!')
            }
          })
        },
        onCancel: () => {
          this.form.dataSource[index].productTypeIdList.push(e)
        }
      })
    },
    allocationAmountChange (e, record, index) {
      const num = this.numMulti(e, this.form.dataSource[index].ratio / 100)
      this.form.dataSource[index].availableAmount = num
      if (!this.form.dataSource[index].resourceTypeName) {
        this.form.dataSource[index].resourceTypeName = ''
      }
      this.form.dataSource[index].allocationAmount = e
      this.form.dataSource[index].remainAmount = (this.form.dataSource[index].allocationAmount - this.form.dataSource[index].distributionAmount).toFixed(3)
      this.getTotal()
    },
    ratioChange (e, record, index) {
      this.ratioState = 1
      const num = this.numMulti(this.form.dataSource[index].allocationAmount, e / 100)
      this.form.dataSource[index].availableAmount = num

      const saleAmount = this.numMulti(this.form.dataSource[index].contractAmount, e / 100)
      this.form.dataSource[index].saleAmount = saleAmount

      if (!this.form.dataSource[index].resourceTypeName) {
        this.form.dataSource[index].resourceTypeName = ''
      }
      this.form.dataSource[index].ratio = e
      this.distributionAmount = this.form.dataSource[index].distributionAmount
      this.getTotal()
    },

    contractAmountChange (e, record, index) {
      const num = this.numMulti(e, this.form.dataSource[index].ratio / 100)
      this.form.dataSource[index].saleAmount = num
      this.form.dataSource[index].contractAmount = e
      this.getTotal()
    },
    // availableChange (e, record, index) {
    //   this.form.dataSource[index].availableAmount = e
    //   this.distributionAmount = this.form.dataSource[index].distributionAmount
    //   this.getTotal()
    // },
    // 选择种类
    typeCancel () {
      this.typeVisible = false
    },
    getNum () {
      let resourceNum = 1
      this.form.dataSource.forEach((item, index) => {
        if (item.resourceType === 1) {
          item.resourceTypeName = '资源包' + resourceNum
          resourceNum++
        } else {
          item.productSelect = true
        }
        item.index = index
      })
    },
    typeOk (data, product) {
      this.typeVisible = false
      if (data === '1') {
        const { count } = this.count
        ++this.resourceIdCount

        const newData = {
          key: count - 1,
          resourceTypeName: '资源包',
          resourceType: 1,
          productTypeIdList: [],
          allocationAmount: '',
          ratio: '',
          availableAmount: '',
          distributionAmount: 0,
          contractAmount: 0,
          saleAmount: 0,
          unit: '个',
          quantity: 0

        }
        this.form.dataSource = [...this.form.dataSource, newData]
        this.count = count + 1
      } else {
        const { count } = this
        const newData = {
          key: count - 1,
          resourceTypeName: product.productTypeName,
          productTypeIdList: [product.productTypeId],
          allocationAmount: '',
          ratio: '',
          availableAmount: '',
          distributionAmount: 0,
          productSelect: true,
          resourceType: 2,
          contractAmount: 0,
          saleAmount: 0,
          unit: '个',
          quantity: 0
        }
        this.form.dataSource = [...this.form.dataSource, newData]

        this.count = count + 1
      }
      this.getNum()
    },
    async handleDelete (record, index) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          if (record.resourceId) {
            await checkResourceDelete(
              {
                resourceId: record.resourceId
              }).then((data) => {
              this.isDelete = data
              if (!this.isDelete) {
                this.$message.error('当前该资源包有发放详情归属数据，无法删除！')
              } else {
                this.form.dataSource = this.form.dataSource.filter((item, intemIndex) => intemIndex !== index)
                this.getNum()
                this.$message.success('删除成功!')
                this.getTotal()
              }
            })
          } else {
            this.form.dataSource = this.form.dataSource.filter((item, intemIndex) => intemIndex !== index)
            this.getNum()
            this.$message.success('删除成功!')
          }
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.ant-select {
  min-width: 150px;
}

.amountClass {
  font-size: 14px;
  padding-left: 40px;
  // .a-pad{
  //   margin:5px 0 10px;
  // }
}

/deep/.ant-form-item-control-wrapper {
  display: inline-block;
}

/deep/.ant-form-item {
  margin-bottom: 0;
}

/deep/.ant-table-row-cell-break-word {
  padding: 20px;
}

.ratioCenter {
  text-align: center;
}
</style>
